import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { EnrollmentService } from '../../services/enrollment.service';
import { ListManagerService } from 'src/app/services/list-manager.service';
import { RegistrationService } from 'src/app/services/registration.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { MatAccordion } from '@angular/material/expansion';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { GuestService } from 'src/app/services/guest.service';
import { PersonalPreferenceService } from 'src/app/services/personal-preference.service';
import { ConstantsService } from 'src/app/services/constants.service';
import * as _ from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import { ContactusComponent } from 'src/app/reusable-components/contactus/contactus.component';
import { MatExpansionPanel } from '@angular/material/expansion';
import { VariablesService } from 'src/app/services/variables.service';

@Component({
  selector: 'app-guest',
  templateUrl: './guest.component.html'
})
export class GuestComponent implements OnInit {
  enrollment;
  isSubmitting = false;
  isFormCompleted = false;
  isRegComplete: any;
  guests: any;
  maxGuests: any;
  programInfo: any;
  attendee: any;
  selectedGuest: any;
  isError: any;
  toBeDeleted: any;
  hasGuestsAttending;
  DisabilityType;
  personalConsiderationsList;
  mealList;
  isNeedingDietaryConsiderations;
  suffixList;
  prefixList;
  guestTypes;
  isDeleting;
  minChildDate;
  varTrack;
  pax;
  varGuest;
  varGuestCityState;
  minChildDate1;
  maxChildDate1;
  minChildDate2;
  maxChildDate2;
  minChildDate3;
  maxChildDate3;
  yesno;
  @ViewChildren(MatExpansionPanel) panels: QueryList<ElementRef>;

  constructor(
    private navigationService: NavigationService,
    public registrationService: RegistrationService,
    private listService: ListManagerService,
    private enrollmentService: EnrollmentService,
    private configurationService: ConfigurationService,
    private guestService: GuestService,
    private personalPreferenceService: PersonalPreferenceService,
    private constantsService: ConstantsService,
    public dialog: MatDialog,
    private variablesService: VariablesService
  ) {

    this.enrollment = this.registrationService.getEnrollment({});
    this.isRegComplete = this.registrationService.isRegistrationComplete();
    this.attendee = this.registrationService.getAttendee({});
    this.pax = this.attendee.PAXTypeNo;
    this.hasGuestsAttending = this.attendee.$mtcHasGuestsAttending;
    this.guests = this.registrationService.getGuests({});
    this.yesno = _.cloneDeep(variablesService.yesno);
    this.listService.getCommonPrefixList().then(list => {
      this.prefixList = list;
    });
    // this.listService.getMealPreferenceList().then(list => {
    //   this.mealList = list;
    // });
    this.mealList = [
      {name: 'None', code: ''},
      {name: 'Dairy-Free', code: 'DAIRYFREE'},
      {name: 'Food Allergy', code: 'FOODALLE'},
      {name: 'Gluten-Free', code: 'GLUTFREE'},
      {name: 'Halal', code: 'HALAL'},
      {name: 'Kosher', code: 'KOSHER'},
      {name: 'No Pork', code: 'NOPORK'},
      {name: 'Pescatarian', code: 'PESCATARIAN'},
      {name: 'Vegan', code: 'VEGAN'},
      {name: 'Vegetarian', code: 'VEGTRIAN'},
      {name: 'Other', code: 'OTHER'}
    ];
    this.personalConsiderationsList = [
      {name: 'None', code: 'NONE'},
      {name: 'Diabetic', code: 'DIABETIC'},
      {name: 'Hearing Impaired', code: 'HRNGIMPD'},
      {name: 'Visually Impaired', code: 'VISLIMPD'},
      {name: 'Wheelchair Access', code: 'WHLCHAIR'},
      {name: 'Other', code: 'OTHER'}
    ];
    // this.listService.getDisabilityList().then(list => {
    //   this.personalConsiderationsList = list;
    // });
    this.listService.getSuffixList().then(list => {
      this.suffixList = list;
    });

    this.varTrack = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varTrack.ID,
      {}
    );

    this.varGuest = registrationService.getVariable(
      this.attendee,
      variablesService.VARIABLE.varGuest.ID,
      {}
    );

    this.isNeedingDietaryConsiderations = this.personalPreferenceService.isNeedingDietaryConsiderations;
    if (this.guests.length > 0) {
      if (!this.areAnyGuestsSelected()) {
        this.selectGuest(_.first(this.guests));
      }
    }
    if (this.guests.length > 0) {
      this.attendee.$mtcHasGuestsAttending = true;
      this.guests.forEach(guest => {
        guest.$mtcHasConsiderations = true;
        //this.needbabysitting = this.registrationService.getVariable(guest, this.variablesService.VARIABLE.BABY_SITTER.ID,{});
        guest.$mtcemail = this.registrationService.getEmail(guest, "BUSINESS", {});
        guest.$mtcphone = this.registrationService.getPhone(guest, "MOBILE", {});
        if ( guest.DietaryConsiderations !== undefined && guest.DietaryConsiderations !== "" ) {
          guest.$mtcHasConsiderations = true;
          if(guest.DietaryConsiderations.indexOf("!") !== -1){
            guest.$mtcmealOther = guest.DietaryConsiderations.slice(guest.DietaryConsiderations.indexOf("!")).replace("!","");
            guest.DietaryConsiderations = guest.DietaryConsiderations.slice(0,guest.DietaryConsiderations.indexOf("!")).replace("!","");
            if ( guest.DietaryConsiderations.includes('Other') ) {
              guest.$mtcdietaryOtherCheckbox = true;
            }
            if ( guest.DietaryConsiderations.includes('Food Allergy') ) {
              guest.$mtcallergyCheckbox = true;
            }
          }
        }else {
          guest.DietaryConsiderations = "";
        }
      });
    }
  }

  ngOnInit(): void {
    this.configurationService.fetchConfig().then((data: any) => {
      this.programInfo = data;
      this.maxGuests = this.programInfo.maxGuests;
    });
    this.guestService.getGuestTypesList().then((gTypes: any) => {
      this.guestTypes = gTypes;
    });

    this.isNeedingDietaryConsiderations = this.personalPreferenceService.isNeedingDietaryConsiderations;
    if (this.guests.length > 0) {
      if (!this.areAnyGuestsSelected()) {
        this.selectGuest(_.first(this.guests));
      }
    }
    if (this.guests.length > 0) {
      this.attendee.$mtcHasGuestsAttending = true;
      this.guests.forEach(guest => {
        //this.needbabysitting = this.registrationService.getVariable(guest, this.variablesService.VARIABLE.BABY_SITTER.ID,{});
        if ( guest.DietaryConsiderations !== undefined && guest.DietaryConsiderations !== "" ) {
          guest.$mtcHasConsiderations = true;
          if(guest.DietaryConsiderations.indexOf("!") !== -1){
            guest.$mtcmealOther = guest.DietaryConsiderations.slice(guest.DietaryConsiderations.indexOf("!")).replace("!","");
            guest.DietaryConsiderations = guest.DietaryConsiderations.slice(0,guest.DietaryConsiderations.indexOf("!")).replace("!","");
            if ( guest.DietaryConsiderations.includes('Other') ) {
              guest.$mtcdietaryOtherCheckbox = true;
            }
            if ( guest.DietaryConsiderations.includes('Food Allergy') ) {
              guest.$mtcallergyCheckbox = true;
            }
          }
        }else {
          guest.DietaryConsiderations = "";
        }
      });
    }

    if (this.guests.length === 0) {
    this.addGuest({});
    }

    this.guestService.getChildMinDate().then(date=>{
      this.minChildDate1 = date;
    });
    this.guestService.getChildMaxDate().then(date=>{
      this.maxChildDate1 = date;
    });

    this.guestService.getChildMinDate2().then(date=>{
      this.minChildDate2 = date;
    });
    this.guestService.getChildMaxDate2().then(date=>{
      this.maxChildDate2 = date;
    });

    this.guestService.getChildMinDate3().then(date=>{
      this.minChildDate3 = date;
    });
    this.guestService.getChildMaxDate3().then(date=>{
      this.maxChildDate3 = date;
    });
  }

  isChild(pax){
    return this.guestService.isChild(pax);
  }
  includes(arr, val) {
    return _.includes(arr, val);
  }

  considerationUpdate(consideration, guest) {
    let justadded = false;

    if (guest.DisabilityType === undefined) {
      guest.DisabilityType = [];
      guest.DisabilityType = this.registrationService.getDisabilities(guest, "");
    }

    if (!_.includes(guest.DisabilityType, consideration.code)) {
      guest.DisabilityType.push(consideration.code);
      justadded = true;
      if(consideration.code === "OTHER"){
        guest.$mtcadaOtherCheckbox = true;
      }
    }
    if (justadded === false && _.includes(guest.DisabilityType, consideration.code)) {
      let index = guest.DisabilityType.indexOf(consideration.code);
      if (index !== -1) {
        guest.DisabilityType.splice(index, 1);
      }
      if(consideration.code === "OTHER"){
        guest.$mtcadaOtherCheckbox = false;
      }
    }
  }

  /**
   * @function isAddGuestEnabled
   * @description Returns if guests is less then the max amount of guests.
   */
  isAddGuestEnabled() {
    return this.guests.length < this.maxGuests;
  }

  /**
   * @function addGuest
   * @description Sets if the attendee has guests attending to true then adds a new guest to the [RegistrationService](./app.RegistrationService.html)
   */
  addGuest(guest) {
    this.isFormCompleted = false;
    guest.$mtcUUID = Math.random();
    if (this.attendee.PAXTypeNo === 21) {
      //only 1 complimentary guest
      guest.PAXTypeNo = 33;
    }
    if (this.attendee.PAXTypeNo === 29) {
      //board member guest
      guest.PAXTypeNo = 41;
    }
    if (this.attendee.PAXTypeNo === 27) {
      //sponsor full conference
      guest.PAXTypeNo = 42;
    }
    if (this.attendee.PAXTypeNo === 23 || this.attendee.PAXTypeNo === 24) {
      //only 1 complimentary guest
      guest.PAXTypeNo = 34;
    }
    if (this.attendee.PAXTypeNo === 50) {
      //only 1 complimentary guest
      guest.PAXTypeNo = 51;
    }

    this.varGuest.Value = "Guest";

    this.varGuestCityState = this.registrationService.getVariable(
      guest,
      this.variablesService.VARIABLE.varGuestCityState.ID,
      {}
    );

    guest.$mtcHasConsiderations = true;
    guest.$mtcdietaryOtherCheckbox;
    guest.$mtcallergyCheckbox;
    guest.$mtcmealOther;
    guest.DietaryConsiderations = "";

    guest.$mtcneedscooter = this.registrationService.getVariable(guest, this.variablesService.VARIABLE.varScooter.ID,{});
    guest.$mtcscootercomments = this.registrationService.getVariable(guest, this.variablesService.VARIABLE.varScooterComments.ID,{});

    let address = this.registrationService.getAddress(this.attendee, "WORK", {});

    this.varGuestCityState.Value = address.City + " " + address.StateProvince;

    this.guests.push(guest);
    this.registrationService.addGuests(guest);
    this.selectGuest(guest);
  }

  /**
   * @function selectGuest
   * @description Used for selecting a specific guest on the page.
   */
  selectGuest(guest) {
    this.guestService.selectGuest(guest);
    // _.each(this.guests, (item) => {
    //   let consideration = this.personalPreferenceService.hasConsiderations(item);
    //   if (item.$mtcHasConsiderations === undefined) {
    //     item.$mtcHasConsiderations = consideration;
    //   }
    // });
    this.selectedGuest = guest;
    return guest;
  }

  /**
   * @function getDisplayName
   * @description Returns the Preferred name for the guest or returns false.
   * @returns {String|Boolean}
   */
  getDisplayName(guest) {
    if (guest) {
      let first = guest.PreferredFirstName || guest.FirstName || "Guest";
      let last = guest.PreferredLastName || guest.LastName || "";
      return first + " " + last;
    } else {
      return false;
    }
  }

  removeExclamation(event){
    if ( event.keyCode === 33 ) {
      return false;
    }
  }

  mealUpdate(guest, meal) {
    if ( meal.name !== undefined ) {
      if ( guest.DietaryConsiderations === undefined ) {
        guest.DietaryConsiderations = "";
      } else {
        if (!guest.DietaryConsiderations.includes(meal.name) && (guest.DietaryConsiderations === "" || guest.DietaryConsiderations === undefined)) {
          guest.DietaryConsiderations =  meal.name;
        } else if (!guest.DietaryConsiderations.includes(meal.name)) {
          guest.DietaryConsiderations =  guest.DietaryConsiderations + "," + meal.name;
        } else {
          guest.DietaryConsiderations = guest.DietaryConsiderations.replace("," + meal.name, "").replace(meal.name, "");
          if(guest.DietaryConsiderations[0] === ","){
            guest.DietaryConsiderations = guest.DietaryConsiderations.slice(1,guest.DietaryConsiderations.length);
          }
        }
      }
    }
  }

  hasdietary(guest) {
    if (guest.DietaryConsiderations !== undefined) {
      if (guest.DietaryConsiderations.length > 1) {
        return true;
      } else {
        return false
      }
    } else {
      return false;
    }
  }

  haspersonalconsiderations(guest) {
    if(!guest.DisabilityType){
      guest.DisabilityType=[];
    }

    if (guest.DisabilityType !== undefined) {
      if (guest.DisabilityType.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  forward(form) {
    this.isSubmitting = true;
    this.isFormCompleted = true;
    this.enrollment.$mtcshowguestselecterror = false;
    if (form.valid || form.disabled) {
      if (!this.attendee.$mtcHasGuestsAttending) {
        this.varGuest.Value = "";
        this.registrationService.removeGuests(this.guests);
      }
      this.guests.forEach((guest) => {
        guest.$mtcIsSelected = false;
       if(!guest.$mtcdietaryOtherCheckbox && !guest.$mtcallergyCheckbox){
          guest.$mtcmealOther = undefined;
        }
        if(!guest.$mtcadaOtherCheckbox){
          guest.PersonalConsiderations = "";
        }
        if(!guest.$mtcHasConsiderations){
          guest.$mtcmealOther = undefined;
          guest.DietaryConsiderations = "";
          guest.DisabilityType = [];
          guest.PersonalConsiderations = "";
        }else if (guest.DietaryConsiderations === undefined && guest.DisabilityType.length === 0) {
          guest.$mtcHasConsiderations = false;
        }
        if ( guest.$mtcmealOther !== "" && guest.$mtcmealOther !== undefined) {
          guest.DietaryConsiderations = guest.DietaryConsiderations + "!" + guest.$mtcmealOther;
        }
      });
      if (this.guests.length > 0) {
        this.guests[0].$mtcIsSelected = true;
      }
      this.navigationService.forward();
    } else {
      this.isError = true;
      this.isSubmitting = false;
      this.enrollment.$mtcshowguestselecterror = true;
    }
  }

  back() {
    // this.personalPreferenceService.commitConsiderationsChanges(this.guests);
    if (!this.attendee.$mtcHasGuestsAttending) {
      this.registrationService.removeGuests(this.guests);
    }
    this.navigationService.back();
  }

  isItemSelected(item) {
    return item.$mtcIsSelected;
  }

  /**
   * @function areAnyGuestsSelected
   */
  areAnyGuestsSelected() {
    return _.some(this.guests, this.isItemSelected);
  }

  /**
   * @function isRemoveGuestEnabled
   * @description Checks if guest removal is enabled on a guest.
   */
  isRemoveGuestEnabled() {
    let filtered = _.filter(this.guests,  (guest) => {
      return !guest.$mtcDeleting;
    });
    return filtered.length > 1;
  }

  /**
   * @function removeGuest
   * @description Removes a guest from the using [RegistrationService.removeGuests()](./app.RegistrationService.html)
   */
  removeGuest(guest) {
    this.isDeleting = true;
    setTimeout(() => {
      this.isDeleting = false;
    }, 500);
    this.toBeDeleted = guest;
    _.remove(this.guests, guest);
    this.registrationService.removeGuests(guest);
    let last = _.last(this.guests);
    this.selectGuest(last === guest ? this.guests[this.guests.length - 1] : last);
  }

  openContact(){
    this.dialog.open(ContactusComponent, { panelClass: 'forgot-dialog-container' });
  }

}
